// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1iZ4p","ranges":"BmiRanges_ranges__4sitC"};